import { create } from 'zustand';
import { UIState } from './types';

/**
 * Global UI Store
 * 
 * Manages application-wide UI state including modals, drawers, and loading states
 */
export const useUIStore = create<UIState>((set) => ({
  // Initial state
  activeModal: null,
  modalData: {},
  globalLoading: false,
  loadingMessage: null,
  isCartOpen: false,
  isMobileMenuOpen: false,
  
  // Modal actions
  openModal: (name, data = {}) => set({ activeModal: name, modalData: data }),
  closeModal: () => set({ activeModal: null, modalData: {} }),
  
  // Loading actions
  setGlobalLoading: (loading, message = null) => 
    set({ globalLoading: loading, loadingMessage: message }),
  
  // Cart drawer actions
  toggleCart: (open) => set((state) => ({ 
    isCartOpen: open !== undefined ? open : !state.isCartOpen 
  })),
  setCartOpen: (open) => set({ isCartOpen: open }),
  
  // Mobile menu actions
  toggleMobileMenu: (open) => set((state) => ({ 
    isMobileMenuOpen: open !== undefined ? open : !state.isMobileMenuOpen 
  })),
  setMobileMenuOpen: (open) => set({ isMobileMenuOpen: open }),
}));
